export enum AssignmentStatus {
  Confirmed = 'Confirmed',
  Unconfirmed = 'Unconfirmed',
  Draft = 'Draft',
}
